/**
 * @author: lv.chen
 * @date: 2025/7/21
 * @desc: 指标切换二次确认弹窗
 */
import React, { useState, useEffect } from 'react';
import classnames from 'classnames';
import { useIntl } from 'umi';
import { Button, Checkbox, Modal } from 'tea-component';
import { getDataSourceIcon } from '@intelligence/utils/getDataSourceImg';
import { getMetricName } from '@intelligence/v3/components/TableComponents/RatioMetricSortBy/utils';

import './index.scss';

interface IMetricSelectConfirmModalProps extends IBaseProps {
  visible: boolean;
  metric?: IPrimaryKeyMetric | null;
  onConfirm?: (dontShowAgain: boolean) => void;
  onCancel?: () => void;
  onClose?: () => void;
}

const MetricSelectConfirmModal: React.FC<IMetricSelectConfirmModalProps> = (props) => {
  const { style, className, visible, metric = null, onConfirm, onCancel, onClose } = props;

  const { locale, formatMessage } = useIntl();

  const [dontShowAgain, setDontShowAgain] = useState(false);

  useEffect(() => {
    if (visible) {
      setDontShowAgain(false);
    }
  }, [visible]);

  if (!metric) return null;
  return (
    <Modal
      style={style}
      className={classnames('dbi-common-modal', className)}
      size={620}
      visible={visible}
      onClose={onClose}
    >
      <Modal.Body>
        <div className="dbi-common-modal__inner">
          <div className="dbi-common-modal__title">{formatMessage({ id: 'dbi_filters_redirect_tips_title' })}</div>
          <div className="dbi-common-modal__body">
            <p>
              {formatMessage(
                { id: 'dbi_filters_redirect_tips_desc1' },
                {
                  metricInfo: (
                    <>
                      <img className="dbi-common-datasource-icon" src={getDataSourceIcon(metric.dataSource)} alt="" />{' '}
                      {getMetricName(locale, metric.dataSource, metric.metric)}
                    </>
                  ),
                },
              )}
            </p>
            <p>{formatMessage({ id: 'dbi_filters_redirect_tips_desc2' })}</p>
          </div>
          <div className="dbi-common-modal__footer">
            <div className="dbi-common-modal__footer-btn-list">
              <Button
                type="primary"
                onClick={(e) => {
                  e?.stopPropagation();
                  onConfirm?.(dontShowAgain);
                }}
              >
                {formatMessage({ id: 'dbi_confirm' })}
              </Button>
              <Button
                onClick={(e) => {
                  e?.stopPropagation();
                  onCancel?.();
                }}
              >
                {formatMessage({ id: 'dbi_cancel' })}
              </Button>
            </div>
            <div className="dbi-common-modal__footer-checkbox-list">
              <Checkbox value={dontShowAgain} onChange={setDontShowAgain}>
                {formatMessage({ id: 'dbi_no_show_again' })}
              </Checkbox>
            </div>
          </div>
        </div>
      </Modal.Body>
    </Modal>
  );
};

export default MetricSelectConfirmModal;
